import React, { useState } from "react";
import { Truck, ExternalLink } from "lucide-react";
import { useSite } from "../../context/SiteContext";

export const detectCarrier = (raw) => {
  const n = (raw || "").replace(/\s+/g, "").toUpperCase();
  if (n.startsWith("1Z") || /^T\d{10}$/.test(n)) return "ups";
  if ((/^\d+$/.test(n) && [20, 22, 26, 30, 34].includes(n.length)) || /^[A-Z]{2}\d{9}US$/.test(n)) return "usps";
  return "";
};

export const trackingUrl = (num, carrier) => carrier === "ups"
  ? `https://www.ups.com/track?tracknum=${encodeURIComponent(num)}`
  : `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(num)}`;

const CarrierButton = ({ num, carrier }) => (
  <a href={trackingUrl(num, carrier)} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-1.5 rounded-full px-5 py-2.5 text-[14.5px] font-semibold text-white transition-colors ${carrier === "ups" ? "bg-[#4b2e1a] hover:bg-[#3a2314]" : "bg-[#333366] hover:bg-[#28284f]"}`} data-testid={`track-package-${carrier}`}>
    {carrier === "ups" ? "UPS" : "USPS"}<ExternalLink size={14} />
  </a>
);

export const TrackPackage = () => {
  const { t } = useSite();
  const [num, setNum] = useState("");
  const clean = num.replace(/\s+/g, "").toUpperCase();
  const carrier = detectCarrier(clean);
  return (
    <div className="sw-card mt-10 p-6 md:p-8" data-testid="track-package-box">
      <h2 className="flex items-center gap-2 text-[20px] font-bold text-[#0f2e2a]"><Truck size={20} className="text-[#0e8c7f]" />{t("Track a package")}</h2>
      <p className="mt-2 text-[14.5px] text-[#5b6d6a]">{t("Paste your USPS or UPS tracking number to see where your package is.")}</p>
      <input value={num} onChange={(e) => setNum(e.target.value)} placeholder={t("e.g. 9400 1118 9922 3197 4284 90")} className="mt-4 w-full rounded-xl border border-[#dcebe8] bg-white px-4 py-3 font-mono text-[15px] outline-none focus:border-[#0e8c7f]" data-testid="track-package-input" />
      {clean.length >= 8 && (
        <div className="mt-4 flex flex-wrap items-center gap-3" data-testid="track-package-result">
          {carrier ? <><span className="text-[14px] text-[#4b5d5a]">{t("Looks like a {c} number:", { c: carrier.toUpperCase() })}</span><CarrierButton num={clean} carrier={carrier} /></>
            : <><span className="text-[14px] text-[#4b5d5a]">{t("Choose your carrier:")}</span><CarrierButton num={clean} carrier="usps" /><CarrierButton num={clean} carrier="ups" /></>}
        </div>
      )}
      <p className="mt-4 text-[12.5px] text-[#8a9a97]">{t("Tracking opens on the official carrier website.")}</p>
    </div>
  );
};
